// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"639204fa","634":"6938652a"}[chunkId] + ".chunk.js";
};